module.exports = __webpack_public_path__ + "static/media/valve.a2409e1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/valve.jpg
// module id = 1020
// module chunks = 0